export enum VisibilityStates {
  BOTHVISIBLE = 'This integration service is visible to everyone within the organizations and teams below',
  TEAMS = 'This integration service is visible to everyone within the teams below',
  ORGANISATIONS = 'This integration is visible to everyone within the organizations below',
  NONE = 'This integration service has not been shared with any organizations or teams and will not be visible to other users',
}

export type dnbOrganization = {
  name: string;
  id: string;
};
